<template>
  <div>
    <div class="reset">
      <ValidationObserver
        v-slot="{ invalid }"
        ref="observer"
        tag="form"
        name="userLoginForm"
        class="form"
        @submit.prevent="validateBeforeSubmit()"
      >
        <InputText
          v-model="form.login_password"
          :label="'新しいパスワード'"
          :type="'password'"
          :maxlength="20"
          :vid="'login_password'"
          rules="required|min:6|max:20"
          class="form__group"
        />

        <InputText
          v-model="form.login_password_confirmation"
          :label="'新しいパスワード(確認)'"
          :type="'password'"
          :maxlength="20"
          rules="required|min:6|max:20|confirmed:login_password"
          class="form__group"
        />

        <!-- Submit Button-->
        <div class="form__group mt72">
          <Btn
            :label="'送信'"
            :color="'red'"
            :disabled="invalid || isLoading"
            :type="'submit'"
          />
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import store from '@/store'
import error from '@/mixin/error.mixin'
import InputText from '@/components/parts/InputText'
import Btn from '@/components/parts/Btn'

export default {
  name: 'PasswordForgotStep03Reset',

  mixins: [error],

  components: {
    mapGetters,
    InputText,
    Btn
  },

  computed: {
    ...mapGetters(['isLoading'])
  },

  data () {
    return {
      form: {
        login_password: '',
        login_password_confirmation: ''
      }
    }
  },

  beforeRouteEnter (from, to, next) {
    if (!store.getters['passwordForgot/code_request_id']) {
      return next({name: 'PasswordForgotStep01Mail'})
    }

    store.commit('loadingAction', false)
    next()
  },

  methods: {
    async validateBeforeSubmit () {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        store.commit('loadingAction', true)
        store.dispatch('passwordForgot/resetPassword', {
          login_password: this.form.login_password,
          login_password_confirmation: this.form.login_password_confirmation
        }).then((_res) => {
          store.commit('loadingAction', false)
          this.$router.push({ name: 'PasswordForgotStep04Complete' }).catch(() => {})
        }).catch((err) => {
          store.commit('loadingAction', false)
          this.addValidateErrors(this.$refs.observer, err)
        })
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/common.css';
  @import '../../assets/css/form.pcss';

  .reset {
    height: 100%;
    overflow: auto;
    margin-top: 50px;
    .form {
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/password-forgot/Step03Reset.vue